import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">

                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What sets TekRevol apart as a mobile app development company in Atlanta?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol stands out for its proven track record of delivering feature-rich, cutting-edge mobile applications. We prioritize seamless navigation, usability, and quick delivery to ensure an incredible experience for the users. Our expert Atlanta app developers use the latest technologies to create personalized solutions for businesses worldwide.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    Is app development in high demand in Atlanta?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The demand for app development in Atlanta is growing by the day and every other business is considering this solution to stay competitive in the market. Different businesses are looking for reliable applications as per their requirements. Atlanta has been already recognized as the tech hub in Georgia and this is high time for any business here to deploy mobile app development.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    How do I find developers to make an app in Atlanta?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>If you are looking for professional mobile app developers in Atlanta, you can consult with us. TekRevol has an experienced team of developers that has already facilitated multiple businesses with full-fledged mobile app solutions.</p>
                                    <p>It is a great opportunity for your business to mark your online presence with the powerful influence of having credible mobile app solutions.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    How much does it cost to develop a mobile app in Atlanta?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The cost of mobile app development in Atlanta may vary according to the requirement and scope of the projects. However, the price range varies from $80k-$250k.
                                        There are different types of mobile app solutions that you can have and the budget may vary according to them between the given range:</p>
                                    <ul>
                                        <li>Native apps</li>
                                        <li>Cross-platform apps</li>
                                        <li>Hybrid apps</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>
                                    How long does it take to develop an App in Atlanta?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The duration of app development in Atlanta usually varies according to the scale of the business and operations. These are factors on which the structure and requirements of the application depend. Meanwhile, the average time frame for the development of a mobile app is between 4-6 months.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>
                                    Is it worth hiring a mobile app development company in Atlanta?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Acquiring the services of a mobile app development company in Atlanta, or any place, depends on your certain project needs and business requirements. Some factors to reflect when determining whether it's worth it or not, include:</p>
                                    <ul>
                                        <li><strong>Expertise:</strong> Atlanta has a developing tech landscape with capable app developers and companies. Study whether the local knowledge aligns with your project's requirements.</li>
                                        <li><strong>Budget:</strong> Local development can have cost benefits, but it's imperative to balance cost with the eminence and skill you require.</li>
                                        <li><strong>Communication:</strong> Closeness can make communication and teamwork more suitable, but remote work is also a choice with contemporary communication channels and tools.</li>
                                        <li><strong>Portfolio:</strong> Estimate the company's previous projects and client references to guarantee they can deliver the quality and features you want.</li>
                                        <li><strong>Project Scope: </strong> For multifaceted or longstanding projects, hiring a local development team may provide benefits in terms of constant support and partnership.</li>
                                    </ul>
                                    <p>Eventually, the decision should be built on a careful valuation of your project's exceptional requirements and your comfort level with the preferred development partner, whether local or remote.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;